import { Typography } from "antd";
import { BOOK_SERVICE_BG } from "assets";

const BookOurService = () => {
  return (
    <section className="book-service-section section-margin-top">
      <img src={BOOK_SERVICE_BG} alt="book-service" />
      <div className="container book-service-section-inner">
        <Typography.Title level={2}>Book Our Service Now</Typography.Title>
        <Typography.Paragraph className="service-desc">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
          pulvinar odio in magna condimentum, et euismod ante rhoncus. Maecenas
          elementum metus quis dolor convallis convallis.
        </Typography.Paragraph>
        <button className="notched-primary-btn contact-us-btn">
          Book Service Now
        </button>
      </div>
    </section>
  );
};

export default BookOurService;
